// extracted by mini-css-extract-plugin
module.exports = {"CatalogButtonScrolled":"catalog_CatalogButtonScrolled__4whpJ","CatalogButton":"catalog_CatalogButton__eirp3","CatalogButtonLanding":"catalog_CatalogButtonLanding__DMMQM"};